import { Component, input, Input, InputSignal, OnInit } from '@angular/core';
import { ApplicationAppEntityApplicationRead, ShipmentAppEntityShipmentRead } from '../../../../../openapi';
import {
  AgreementsDataPreviewComponent
} from '../../common/agreements-data-section/components/agreements-data-preview/agreements-data-preview.component';
import {
  ApplicantPreviewComponent
} from '../../common/applicant-data-section/components/applicant-preview/applicant-preview.component';
import {
  ApplicationDataPreviewComponent
} from '../../common/application-data-section/components/application-data-preview/application-data-preview.component';
import {
  AttachmentsDataPreviewComponent
} from '../../common/attachments-data-section/components/attachments-data-preview/attachments-data-preview.component';
import { CommonModule, DatePipe } from '@angular/common';
import { DecisionDataPreviewComponent } from '../../common/decision-data-preview/decision-data-preview.component';
import {
  IrspaDetailedInformationOnTheLetterContentPreviewComponent
} from '../../common/irspa-detailed-information-on-the-letter-content-section/components/irspa-detailed-information-on-the-letter-content-preview/irspa-detailed-information-on-the-letter-content-preview.component';
import {
  IrspaLetterContentPreviewComponent
} from '../../common/irspa-letter-content-section/components/irspa-letter-content-preview/irspa-letter-content-preview.component';
import { LabelComponent } from '../../../../../common/label/label.component';
import {
  DrawAndModifyTerrainComponent
} from '../../../../../common/draw-and-modify-terrain/draw-and-modify-terrain.component';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-irspa-warning-on-the-consulted-draft-preview',
  standalone: true,
  imports: [
    AgreementsDataPreviewComponent,
    ApplicantPreviewComponent,
    ApplicationDataPreviewComponent,
    AttachmentsDataPreviewComponent,
    DatePipe,
    DecisionDataPreviewComponent,
    IrspaDetailedInformationOnTheLetterContentPreviewComponent,
    IrspaLetterContentPreviewComponent,
    LabelComponent,
    CommonModule,
    DrawAndModifyTerrainComponent,
    FormsModule
  ],
  templateUrl: './irspa-warning-on-the-consulted-draft-preview.component.html'
})
export class IrspaWarningOnTheConsultedDraftPreviewComponent implements OnInit {

  @Input()
  public expanded: boolean = true;

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public shipments: InputSignal<ShipmentAppEntityShipmentRead[]> = input<ShipmentAppEntityShipmentRead[]>([]);

  public canPay: InputSignal<boolean> = input<boolean>(false);

  public ngOnInit(): void {
  }

}
